
































































import Vue from 'vue';

export default Vue.extend({
  name: 'App',

  data: () => ({
    dialog: false,
    langs: [
      { text: 'appbar.langs.ja', value: 'ja' },
      { text: 'appbar.langs.en', value: 'en' },
    ],
    menuitem: [
      {
        icon: 'mdi-translate',
        name: 'appbar.lang',
        link: '__dialog',
      },
      {
        icon: 'mdi-update',
        name: 'appbar.changelog',
        link: 'https://github.com/BlueSheep2804/r5rtool/blob/master/Changelog.md',
      },
      {
        icon: 'mdi-github',
        name: 'appbar.source_code',
        link: 'https://github.com/BlueSheep2804/r5rtool',
      },
      {
        icon: 'mdi-twitter',
        name: 'appbar.twitter_author',
        link: 'https://twitter.com/BlueSheep2804',
      },
    ],
  }),
});
